"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cecima": {
    "5119bf14": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "skipSearch": false
    }],
    "campalbino": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8c1f5912": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "skipSearch": false
    }],
    "campopiano": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9670698": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "skipSearch": false
    }],
    "casa-monte": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "04a5e84b": [{
      "hkey": "749b3e49",
      "slug": "casa-zanre-lucchelli",
      "name": "Casa Zanrè-Lucchelli",
      "primary": true,
      "skipSearch": false
    }],
    "casa-zazze": [{
      "hkey": "749b3e49",
      "slug": "casa-zanre-lucchelli",
      "name": "Casa Zanrè-Lucchelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8adb0804": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-allegrini": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6a72fbd9": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-caloccina": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "265d7a98": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "skipSearch": false
    }],
    "colletta": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "61a3efbe": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "skipSearch": false
    }],
    "colombaia": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "78dc08ea": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "skipSearch": false
    }],
    "isola": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1bab4243": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "skipSearch": false
    }],
    "molino": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1804070b": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "skipSearch": false
    }],
    "san-colombano": [{
      "hkey": "cd0baadb",
      "slug": "cecima",
      "name": "Cecima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;